'use strict';

import { EventEmitter } from 'events';
import assign from 'object-assign';
import TngAppDispatcher from '../dispatcher/TngAppDispatcher';

import processAction from 'services/storeUtils';
import _ from 'underscore';

import appConstants from 'constants/appConstants';

var _teams = {};
var _currentTeam = {};
var _currentMultiTeams = {};
var _activationStatuses = {};

//var _membersOnLeave = {};
var _newlyAddedTeam = {};
var _filteredTeams = [];
var _unassignedTeams = {};

var _storeStatus = {
    msg: null,
    success: false,
    loading: false,
};


/**
 * Create a TEAM item.
 * @param  {string} teamName The name of the TEAM
 */
var addTeam = function (response) {
    //_storeStatuses = processAction(response);
    var actions = processAction(response, function (responseBody) {
        _newlyAddedTeam.Id = responseBody;
    });

    _newlyAddedTeam.loading = actions.loading;
    _newlyAddedTeam.error = actions.error;
};

var editTeam = function (response) {
    var actions = processAction(response);

    _currentTeam.loading = actions.loading;
    _currentTeam.error = actions.error;
};

var deleteTeam = function (response) {
    var actions = processAction(response);

    _currentTeam.loading = actions.loading;
    _currentTeam.error = actions.error;
};

var loadTeams = function (response) {
    var actions = processAction(response, function (responseBody) {
        _teams.teams = responseBody.Items;
        _teams.nextPageLink = responseBody.NextPageLink;
    });

    _teams.loading = actions.loading;
    _teams.error = actions.error;
};


var loadTeamsByDisplayType = function (response) {
    if (!_teams.display_types) {
        _teams.display_types = {};
    }

    if (!_teams.display_types[response.queryParams.displayTypeId]) {
        _teams.display_types[response.queryParams.displayTypeId] = {};
    }

    var actions = processAction(response, function (responseBody) {
        _teams.display_types[response.queryParams.displayTypeId] = responseBody;
    });

    _teams.display_types[response.queryParams.displayTypeId].loading = actions.loading;
    _teams.display_types[response.queryParams.displayTypeId].error = actions.error;
};

var loadMoreTeamsByDisplayType = function (response) {
    var actions = processAction(response, function (responseBody) {
        _teams.display_types[response.queryParams.displayTypeId].Items = _teams.display_types[response.queryParams.displayTypeId].Items.concat(responseBody.Items);
        _teams.display_types[response.queryParams.displayTypeId].NextPageLink = responseBody.NextPageLink;
    });

    _teams.display_types[response.queryParams.displayTypeId].loading = actions.loading;
    _teams.display_types[response.queryParams.displayTypeId].error = actions.error;
};

var loadMoreTeams = function (response) {
    if (response.queryParams && response.queryParams.displayTypeId) {
        loadMoreTeamsByDisplayType(response);
    } else {
        var actions = processAction(response, function (responseBody) {
            _teams.teams = _teams.teams.concat(responseBody.Items);
            _teams.nextPageLink = responseBody.NextPageLink;
        });

        _teams.loading = actions.loading;
        _teams.error = actions.error;        
    }
};

var loadSingleTeam = function (response) {

    var actions = processAction(response, function (responseBody) {

        if (_currentTeam.teamId && _currentTeam.teamId !== responseBody.Id) {
            _currentTeam = {};
        }

        _currentTeam.team = responseBody;
    });

    _currentTeam.loading = actions.loading;
    _currentTeam.error = actions.error;
};

var loadSingleTeamMembers = function (response, roleType) {

    if (!_currentTeam.teamMembers || _currentTeam.teamId && _currentTeam.teamId !== response.queryParams.teamId) {
        _currentTeam.teamMembers = {};
    }

    _currentTeam.teamId = response.queryParams.teamId;

    if (roleType === undefined) {
        roleType = 'employees';
    }

    if (!_currentTeam.teamMembers[roleType]) {
        _currentTeam.teamMembers[roleType] = {};
        _currentTeam.teamMembers[roleType][appConstants.ENUMS.TEAM_VIEW_OPTIONS.SUMMARY] = {};
        _currentTeam.teamMembers[roleType][appConstants.ENUMS.TEAM_VIEW_OPTIONS.LEAVE] = {};
    }

    var actions = processAction(response, function (responseBody) {
        _currentTeam.teamMembers[roleType][response.queryParams.viewType] = responseBody;

        if (_.isEmpty(_currentTeam.teamMembers[roleType][appConstants.ENUMS.TEAM_VIEW_OPTIONS.SUMMARY])) {
            _currentTeam.teamMembers[roleType][appConstants.ENUMS.TEAM_VIEW_OPTIONS.SUMMARY] = responseBody;
        } else if (_.isEmpty(_currentTeam.teamMembers[roleType][appConstants.ENUMS.TEAM_VIEW_OPTIONS.LEAVE])) {
            _currentTeam.teamMembers[roleType][appConstants.ENUMS.TEAM_VIEW_OPTIONS.LEAVE] = responseBody;
        }
    });

    _currentTeam.teamMembers[roleType][response.queryParams.viewType].loading = actions.loading;
    _currentTeam.teamMembers[roleType][response.queryParams.viewType].error = actions.error;
    
};

var loadMultipleTeams = function (response) {

    _currentMultiTeams = {};

    var actions = processAction(response, function (responseBody) {
        
        responseBody.forEach(team => {
            _currentMultiTeams[team.Id] = {};
            _currentMultiTeams[team.Id].team = team;
        });

    });
    _currentMultiTeams.loading = actions.loading;
    _currentMultiTeams.error = actions.error;
};

var loadMultipleTeamMembers = function (response, roleType) {

    if (roleType === undefined) {
        roleType = 'employees';
    }

    var actions = processAction(response, function (responseBody) {
        
        responseBody.forEach(teamMembersByType => {
            const teamId = teamMembersByType.Fields.TeamId;
            const currentTeam = _currentMultiTeams[teamId];

            if (currentTeam) {
                if (!currentTeam.teamMembers) {
                    currentTeam.teamMembers = {};
                }

                if (!currentTeam.teamMembers[roleType]) {
                    currentTeam.teamMembers[roleType] = {};
                }
            }

            currentTeam.teamMembers[roleType][response.queryParams.viewType] = teamMembersByType;

            _currentMultiTeams[teamId] = currentTeam;
        });

    });

    _teams.loading = actions.loading;
    _teams.error = actions.error;
};

var loadMoreTeamMembers = function (response, roleType) {
    
    let currentTeam = _currentTeam;

    if (response.queryParams.isMultiTeamView) {
        currentTeam = _currentMultiTeams[response.queryParams.teamId];
    }

    if (!currentTeam.teamMembers) {
        currentTeam.teamMembers = {};
    }

    if (roleType === undefined) {
        roleType = 'employees';
    }

    if (!currentTeam.teamMembers[roleType]) {
        currentTeam.teamMembers[roleType] = {};
        currentTeam.teamMembers[roleType][appConstants.ENUMS.TEAM_VIEW_OPTIONS.SUMMARY] = {};
        currentTeam.teamMembers[roleType][appConstants.ENUMS.TEAM_VIEW_OPTIONS.LEAVE] = {};
    }

    var actions = processAction(response, function (responseBody) {

        currentTeam.teamMembers[roleType][response.queryParams.viewType].Items = currentTeam.teamMembers[roleType][response.queryParams.viewType].Items.concat(responseBody.Items);
        currentTeam.teamMembers[roleType][response.queryParams.viewType].Page = responseBody.Page;
        currentTeam.teamMembers[roleType][response.queryParams.viewType].PageSize = responseBody.PageSize;
        currentTeam.teamMembers[roleType][response.queryParams.viewType].TotalCount = responseBody.TotalCount;
    });

    currentTeam.teamMembers[roleType][response.queryParams.viewType].loading = actions.loading;
    currentTeam.teamMembers[roleType][response.queryParams.viewType].error = actions.error;

    if (response.queryParams.isMultiTeamView) {
        _currentMultiTeams[response.queryParams.teamId] = currentTeam;
    } else {
        _currentTeam = currentTeam;
    }
};

var loadFilteredTeams = function (response) {
    if (!_filteredTeams) {
        _filteredTeams = {};
    }

    if (!_filteredTeams.teams) {
        _filteredTeams.teams = [];
    }

    var actions = processAction(response, function (responseBody) {
        _filteredTeams.teams = responseBody;
    });

    _filteredTeams.loading = actions.loading;
    _filteredTeams.error = actions.error;
    _filteredTeams.searchTerm = response.queryParams.searchTerm;
};

var loadTeamMembersCount = function (response) {
    if (!_teams.membershipCounts) {
        _teams.membershipCounts = {};
    }

    var actions = processAction(response, function (responseBody) {
        _teams.membershipCounts.items = responseBody;
    });

    _teams.membershipCounts.loading = actions.loading;
    _teams.membershipCounts.error = actions.error;
};

var loadUserManagers = function (response) {
    if (!_teams.usersManagers) {
        _teams.usersManagers = {};
    }

    var actions = processAction(response, function (responseBody) {
        _teams.usersManagers.items = responseBody;
    });

    _teams.usersManagers.loading = actions.loading;
    _teams.usersManagers.error = actions.error;
};

var loadUsersMembersOnLeave = function (response) {
    if (!_teams.usersMembersOnLeave) {
        _teams.usersMembersOnLeave = {};
    }

    var actions = processAction(response, function (responseBody) {
        _teams.usersMembersOnLeave.items = responseBody;
    });

    _teams.usersMembersOnLeave.loading = actions.loading;
    _teams.usersMembersOnLeave.error = actions.error;
};

var loadUnassignedTeamInfo = function (response) {    

    if (!_teams.UnassignedTeamInfo) {
        _teams.UnassignedTeamInfo = {};
    }

    var actions = processAction(response, function (responseBody) {
        _unassignedTeams = responseBody;
    });

    _unassignedTeams.loading = actions.loading;
    _unassignedTeams.error = actions.error;
};

var getPeopleActivationStatuses = function (response) {
    if (!_activationStatuses) {
        _activationStatuses = {};
    }

    var actions = processAction(response, function (responseBody) {
        _activationStatuses = responseBody;
    });

    _activationStatuses.loading = actions.loading;
    _activationStatuses.error = actions.error;
};

var TeamStore = assign({}, EventEmitter.prototype, {
    addChangeListener(callback) {
        TeamStore.on(appConstants.events.CHANGE, callback);
    },
    removeChangeListener(callback) {
        TeamStore.removeListener(appConstants.events.CHANGE, callback);
    },
    addUpdateChangeListener(callback) {
        TeamStore.on(appConstants.events.UPDATE_TEAM, callback);
    },
    removeUpdateChangeListener(callback) {
        TeamStore.removeListener(appConstants.events.UPDATE_TEAM, callback);
    },
    addChangeSingleTeamListener(callback) {
        this.on(appConstants.events.CHANGE_SINGLE_TEAM, callback);
    },
    removeChangeSingleTeamListener(callback) {
        this.removeListener(appConstants.events.CHANGE_SINGLE_TEAM, callback);
    },
    addDeleteSingleTeamListener(callback) {
        this.on(appConstants.events.DELETE_TEAM, callback);
    },
    removeDeleteSingleTeamListener(callback) {
        this.removeListener(appConstants.events.DELETE_TEAM, callback);
    },
    addChangeUnassignedTeamListener(callback) {
        this.on(appConstants.events.CHANGE_UNASSIGNED_TEAM, callback);
    },
    removeChangeUnassignedTeamListener(callback) {
        this.removeListener(appConstants.events.CHANGE_UNASSIGNED_TEAM, callback);
    },
    addActivateAllUserListener(callback) {
        this.on(appConstants.events.ACTIVATE_ALL_USERS, callback);
    },
    removeActivateAllUserListener(callback) {
        this.removeListener(appConstants.events.ACTIVATE_ALL_USERS, callback);
    },
    addChangeMultipleTeamsListener(callback) {
        this.on(appConstants.events.CHANGE_MULTIPLE_TEAMS, callback);
    },
    removeChangeMultipleTeamsListener(callback) {
        this.removeListener(appConstants.events.CHANGE_MULTIPLE_TEAMS, callback);
    },
    addChangeMultipleTeamMembersListener(callback) {
        this.on(appConstants.events.CHANGE_MULTIPLE_TEAM_MEMBERS, callback);
    },
    removeChangeMultipleTeamMembersListener(callback) {
        this.removeListener(appConstants.events.CHANGE_MULTIPLE_TEAM_MEMBERS, callback);
    },
    addGetActivationStatusListener(callback) {
        this.on(appConstants.events.GET_PEOPLE_ACTIVATION_STATUS, callback);
    },
    removeGetActivationStatusListener(callback) {
        this.removeListener(appConstants.events.GET_PEOPLE_ACTIVATION_STATUS, callback);
    },    

    getTeamData() {
        return _teams;
    },
    getTeam() {
        return _currentTeam;
    },
    getMultipleTeams() {
        return _currentMultiTeams;    
    },
    // getMultipleTeamMembers() {
    //     return _currentMultiTeamMembers;    
    // },
    // getMultipleTeamManagers() {
    //     return _currentMultiTeamManagers;    
    // },
    getLatestAddedTeam() {
        return _newlyAddedTeam;
    },
    resetSingleTeam() {
        _currentTeam = {};
    },
    resetMultipleTeams() {
        _currentMultiTeams = [];
    },
    getFilteredTeams() {
        return _filteredTeams;
    },
    getUnassignedTeamData() {
        return _unassignedTeams;
    },
    getStatus() {
        return _storeStatus;
    },
    getActivationStatus() {
        return _activationStatuses;
    },
});


TeamStore.dispatchToken = TngAppDispatcher.register(function (payload) {
    var action = payload.action;
    switch (action.actionType) {
        case appConstants.actions.TEAMS.GET_ALL_TEAMS:
            loadTeams(action);
            TeamStore.emit(appConstants.events.CHANGE);
            break;

        case appConstants.actions.TEAMS.GET_ALL_TEAMS_BY_DISPLAY_TYPE:
            loadTeamsByDisplayType(action);
            TeamStore.emit(appConstants.events.CHANGE);
            break;

        case appConstants.actions.TEAMS.GET_MORE_TEAMS:
            loadMoreTeams(action);
            TeamStore.emit(appConstants.events.CHANGE);
            break;

        case appConstants.actions.TEAMS.GET_SINGLE_TEAM:
            loadSingleTeam(action);
            TeamStore.emit(appConstants.events.CHANGE_SINGLE_TEAM);
            break;
        
        case appConstants.actions.TEAMS.GET_SINGLE_TEAM_MEMBERS:
            loadSingleTeamMembers(action);
            TeamStore.emit(appConstants.events.CHANGE_SINGLE_TEAM);
            break;

        case appConstants.actions.TEAMS.GET_MORE_SINGLE_TEAM_MEMBERS:
            loadMoreTeamMembers(action);
            TeamStore.emit(appConstants.events.CHANGE_SINGLE_TEAM);
            break;

        case appConstants.actions.TEAMS.GET_SINGLE_TEAM_MANAGERS:
            loadSingleTeamMembers(action, 'managers');
            TeamStore.emit(appConstants.events.CHANGE_SINGLE_TEAM);
            break;

        case appConstants.actions.TEAMS.GET_MORE_SINGLE_TEAM_MANAGERS:
            loadMoreTeamMembers(action, 'managers');
            TeamStore.emit(appConstants.events.CHANGE_SINGLE_TEAM);
            break;

        case appConstants.actions.TEAMS.GET_MULTIPLE_TEAMS:
            loadMultipleTeams(action);
            TeamStore.emit(appConstants.events.CHANGE_MULTIPLE_TEAMS);
            break;
        
        case appConstants.actions.TEAMS.GET_MULTIPLE_TEAM_MEMBERS:
            loadMultipleTeamMembers(action);
            TeamStore.emit(appConstants.events.CHANGE_MULTIPLE_TEAMS);
            break;

        case appConstants.actions.TEAMS.GET_MULTIPLE_TEAM_MANAGERS:
            loadMultipleTeamMembers(action, 'managers');
            TeamStore.emit(appConstants.events.CHANGE_MULTIPLE_TEAMS);
            break;

        case appConstants.actions.TEAMS.ADD_TEAM:
            TeamStore.emit(appConstants.events.CHANGE);
            addTeam(action);
            TeamStore.emit(appConstants.events.UPDATE_TEAM);
            break;

        case appConstants.actions.TEAMS.EDIT_TEAM:
            editTeam(action);
            TeamStore.emit(appConstants.events.CHANGE_SINGLE_TEAM);
            break;

        case appConstants.actions.TEAMS.DELETE_TEAM:
            deleteTeam(action);
            TeamStore.emit(appConstants.events.DELETE_TEAM);
            break;

        case appConstants.actions.TEAMS.LOAD_FILTERED_TEAMS:
            loadFilteredTeams(action);
            TeamStore.emit(appConstants.events.CHANGE);
            break;

        case appConstants.actions.TEAMS.GET_TEAM_MEMBERS_COUNT:
            loadTeamMembersCount(action);
            TeamStore.emit(appConstants.events.CHANGE);
            break;

        case appConstants.actions.TEAMS.GET_USERS_MANAGERS:
            loadUserManagers(action);
            TeamStore.emit(appConstants.events.CHANGE);
            break;

        case appConstants.actions.TEAMS.GET_USERS_MEMBERS_ON_LEAVE:
            loadUsersMembersOnLeave(action);
            TeamStore.emit(appConstants.events.CHANGE);
            break;
        case appConstants.actions.TEAMS.GET_UNASSIGNED_TEAM_INFO:
            loadUnassignedTeamInfo(action);
            TeamStore.emit(appConstants.events.CHANGE_UNASSIGNED_TEAM);
            break;

        case appConstants.actions.TEAMS.GET_PEOPLE_ACTIVATION_STATUS:
            getPeopleActivationStatuses(action);
            TeamStore.emit(appConstants.events.GET_PEOPLE_ACTIVATION_STATUS);
            break;
        default:
            return true;
    }

    return true;
});

export default TeamStore;
